import { OrderStorageDTO } from 'interfaces';

export const getStorageAddressLabel = (storage: OrderStorageDTO) =>
   `${storage.address.name}\n${storage.address.street}, ${storage.address.zipCode} ${storage.address.city}`;
